import { type SelectOption } from '../../../../../components/SelectDropdown/SelectDropdown'
import { type CSSObjectWithLabel, type ControlProps } from 'react-select'
import { type TaskCategoryEntityTypeConfig } from './TasksTable'

export const reactSelectBaseStyles = {
  menu: (base: CSSObjectWithLabel) => ({
    ...base,
    width: 'max-content',
    minWidth: '100%',
    border: '0px solid white',
    boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.35)',
  }),
  menuPortal: (base: CSSObjectWithLabel) => ({ ...base, zIndex: 9999999 }),
  option: (base: CSSObjectWithLabel) => ({
    ...base,
    color: '#000',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    ':hover': { backgroundColor: '#f1f1f1' },
  }),
  control: (base: CSSObjectWithLabel, state: ControlProps<SelectOption>) => ({
    ...base,
    borderColor: state.isFocused ? 'var(--zocks-primary)' : 'var(--zocks-gray-500)',
    boxShadow: 'none',
    '&:hover': {
      borderColor: state.isFocused ? 'var(--zocks-primary)' : 'var(--zocks-gray-500)',
    },
  }),
}

export const taskCategoryEntityType: Record<string, TaskCategoryEntityTypeConfig> = {
  wealthbox: { api: 'task_categories', dto: 'taskCategories' },
  redtail: { api: 'categories', dto: 'categories' },
  smartoffice: { api: 'static', dto: 'static' },
}

export interface ActivityTemplate {
  id: number
  name: string
  body: string | null
  subject: string | null
  description: string | null
  category: string | null
  categoryId: number | null
  allDay: boolean
  typeId: number | null
  importance: number | null
  priority: number | null
  assignToCurrentUser: boolean
}

export const REDTAIL_PRIORITY_MAP: Record<number, string> = {
  1: 'Low',
  2: 'Low',
  3: 'Medium',
  4: 'Medium',
  5: 'High',
  6: 'High',
}

export const REDTAIL_IMPORTANCE_MAP: Record<number, string> = {
  1: 'Low',
  2: 'Normal',
  3: 'High',
}

export const REDTAIL_ACTIVITY_TYPE_OPTIONS: SelectOption[] = [
  { id: '1', label: 'Task' },
  { id: '2', label: 'Appointment' },
  { id: '3', label: 'Phone call' },
  { id: '4', label: 'Unassigned' },
]
